import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lineTruncator'
})
export class LineTruncatorPipe implements PipeTransform {

  /**
   * Ограничение максимальной длины отображаемой строки
   * @param value Входная строка
   * @param lengthOfLine Максимальное количество символов, отображаемое на одной строке
   * @param numberOfLines Количество отображаемых строк
   */
  transform(value: string, lengthOfLine?: number, numberOfLines?: number): any {
    if (lengthOfLine) {
      let resultString = '';
      const words = value.split(' ');
      let linesCounter = 1;
      const resultArray: string[] = [];
      let i = 1;
      for (i = 0; i < words.length && linesCounter <= numberOfLines; i++) {
        resultArray.push(words[i]);
        const arg = linesCounter === (numberOfLines) ? 3 : 0;
        if (resultArray.join(' ').length > (lengthOfLine - arg)) {
          if (linesCounter === (numberOfLines)) {
            resultString = [resultString.trim(), '...'].join(' ');
          } else {
            resultArray.splice(0, resultArray.length);
            resultArray.push(words[i]);
            resultString = [resultString.trim(), words[i]].join(' ');
          }
          linesCounter++;
        } else {
          resultString = [resultString.trim(), words[i]].join(' ');
        }
      }
      return resultString;
    }

    return value;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/line-truncator.pipe.ts